interface NextStepProps {
  onOpenForm: () => void;
}

export default function NextStep({ onOpenForm }: NextStepProps) {
  return (
    <section className="py-24 px-6 bg-gray-50">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            接下來可以怎麼做？
          </h2>
          <div className="w-20 h-1 bg-teal-500 mx-auto"></div>
        </div>

        <div className="bg-white rounded-2xl p-10 md:p-14 shadow-sm border border-gray-100">
          <p className="text-lg md:text-xl text-gray-700 leading-relaxed mb-6 text-center">
            你可以先了解這樣的管理方式，<br />
            是否符合你對網站的期待。
          </p>
          <p className="text-lg md:text-xl text-gray-700 leading-relaxed text-center">
            若你希望有人長期協助處理網站相關事項，<br />
            我們可以再依你的實際需求，<br />
            <strong className="text-teal-600">說明適合的年度管理方案內容</strong>。
          </p>
        </div>

        <div className="mt-12 text-center">
          <a 
            href="/consultation"
            className="inline-flex items-center justify-center px-10 py-5 bg-teal-500 text-white text-lg font-semibold rounded-lg hover:bg-teal-600 transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
          >
            <i className="ri-question-answer-line mr-3 text-xl"></i>
            進一步諮詢與了解
          </a>
          <p className="mt-6 text-sm text-gray-500">
            我們會根據您的實際情況，提供適合的建議
          </p>
        </div>

        <div className="mt-16 bg-gradient-to-br from-gray-50 to-white rounded-xl p-8 border border-gray-200">
          <div className="flex items-start">
            <i className="ri-information-line text-teal-500 text-2xl mr-4 mt-1 flex-shrink-0"></i>
            <div>
              <h4 className="text-base font-semibold text-gray-900 mb-2">說明導向，非銷售導向</h4>
              <p className="text-sm text-gray-600 leading-relaxed">
                本頁面僅作為說明與理解用途，協助您評估這種管理方式是否符合需求。我們不提供促銷或限時優惠，而是以長期合作的角度，協助您找到適合的網站管理方式。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}